import React, { useState, useEffect } from "react";
import { uploadImageToCloudinary } from "../cloudinary";
import { db } from "../firebase";
import { collection, addDoc, updateDoc, doc, onSnapshot } from "firebase/firestore";

const AddProductModal = ({ isOpen, onClose, onProductAdded, productToEdit }) => {
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [isNew, setIsNew] = useState(false);
  const [isFeatured, setIsFeatured] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);

  // Cargar categorías en tiempo real
  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "categorias"), (snapshot) => {
      setCategories(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
    return () => unsubscribe();
  }, []);

  // Precarga datos si es edición
  useEffect(() => {
    if (productToEdit) {
      setName(productToEdit.name || "");
      setPrice(productToEdit.price || "");
      setDescription(productToEdit.description || "");
      setCategory(productToEdit.category || "");
      setIsNew(productToEdit.isNew || false);
      setIsFeatured(productToEdit.isFeatured || false);
      setImagePreview(productToEdit.image || null);
      setImageFile(null);
    } else {
      setName(""); setPrice(""); setDescription(""); setCategory("");
      setIsNew(false); setIsFeatured(false); setImagePreview(null); setImageFile(null);
    }
  }, [productToEdit, isOpen]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    let imageUrl = imagePreview;
    if (imageFile) {
      imageUrl = await uploadImageToCloudinary(imageFile);
    }
    const productData = {
      name,
      price: Number(price),
      description,
      category,
      isNew,
      isFeatured,
      image: imageUrl,
      updatedAt: new Date(),
    };
    if (productToEdit) {
      await updateDoc(doc(db, "productos", productToEdit.id), productData);
    } else {
      await addDoc(collection(db, "productos"), {
        ...productData,
        createdAt: new Date(),
      });
    }
    setLoading(false);
    onProductAdded();
    onClose();
    setName(""); setPrice(""); setDescription(""); setCategory("");
    setIsNew(false); setIsFeatured(false); setImageFile(null); setImagePreview(null);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
      <form
        onSubmit={handleSubmit}
        className="bg-white rounded-xl shadow-2xl p-8 w-full max-w-md relative"
      >
        <h2 className="text-2xl font-bold mb-4 text-center">
          {productToEdit ? "Editar Producto" : "Agregar Producto"}
        </h2>

        {/* Nombre */}
        <input
          type="text"
          placeholder="Nombre"
          className="w-full p-2 mb-3 border rounded"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />

        {/* Precio */}
        <input
          type="number"
          placeholder="Precio"
          className="w-full p-2 mb-3 border rounded"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          required
          min={0}
        />

        {/* Descripción */}
        <textarea
          placeholder="Descripción"
          className="w-full p-2 mb-3 border rounded"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          required
        />

        {/* Selección de categoría */}
        <select
          className="w-full p-2 mb-3 border rounded"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          required
        >
          <option value="">Selecciona una categoría</option>
          {categories.map(cat => (
            <option key={cat.id} value={cat.name}>
              {cat.name}
            </option>
          ))}
        </select>

        {/* Checkboxes */}
        <div className="flex gap-6 mb-3">
          <label className="flex items-center gap-2">
            <input type="checkbox" checked={isNew} onChange={e => setIsNew(e.target.checked)} />
            Producto Nuevo
          </label>
          <label className="flex items-center gap-2">
            <input type="checkbox" checked={isFeatured} onChange={e => setIsFeatured(e.target.checked)} />
            Destacado
          </label>
        </div>

        {/* Imagen */}
        <input
          type="file"
          accept="image/*"
          className="mb-3"
          onChange={handleImageChange}
          required={!productToEdit}
        />
        {imagePreview && (
          <img src={imagePreview} alt="preview" className="w-32 h-32 object-cover mb-4 mx-auto rounded" />
        )}

        {/* Botones */}
        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition-all"
          disabled={loading}
        >
          {loading
            ? productToEdit
              ? "Actualizando..."
              : "Subiendo..."
            : productToEdit
              ? "Actualizar Producto"
              : "Guardar Producto"}
        </button>
        <button
          type="button"
          className="w-full mt-3 text-gray-500 hover:text-gray-900"
          onClick={onClose}
        >
          Cancelar
        </button>
      </form>
    </div>
  );
};

export default AddProductModal;
